import { useEffect, useState } from 'react';
import { impersonateAsUserKey, readAccessToken } from '../Auth';
import './ImpersonationBanner.css';
import { parseUserProfileFCString } from '@arkitektbedriftene/fe-lib/oidc';

interface ImpersonationInfo {
  username: string;
  firmid: string;
}

export const ImpersonationBanner = () => {
  const [impersonationInfo, setImpersonationInfo] = useState<ImpersonationInfo | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const checkImpersonation = () => {
      const adminTokenStr = localStorage.getItem(impersonateAsUserKey);
      if (adminTokenStr) {
        try {
          const token = JSON.parse(adminTokenStr);
          const jwt = readAccessToken(token.access_token)
          const firmAccess = parseUserProfileFCString(jwt.fc)[0]
          console.log(firmAccess)
          setImpersonationInfo({
            username: token.username,
            firmid: firmAccess.CustomerExternalId
          });
        } catch (e) {
          console.error('Error parsing impersonation token:', e);
        }
      } else {
        setImpersonationInfo(null);
      }
    };

    // Check on mount and set up storage event listener
    checkImpersonation();
    window.addEventListener('storage', checkImpersonation);

    return () => {
      window.removeEventListener('storage', checkImpersonation);
    };
  }, []);

  if (!impersonationInfo) return null;

  return (
    <div
      className={`impersonation-banner ${isHovered ? 'hovered' : ''}`}
      title={`Impersonating: ${impersonationInfo.username} | Customer ID: ${impersonationInfo.firmid}. Klikk for å avslutte.`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        if (window.confirm('Stop impersonation?')) {
          localStorage.removeItem(impersonateAsUserKey);
          window.location.reload();
        }
      }}
    >
      <div className="banner-content">
        {impersonationInfo.username} | {impersonationInfo.firmid} &nbsp;&nbsp;&nbsp;&nbsp;(Klikk for å avslutte)
      </div>
    </div>
  );
};

export default ImpersonationBanner;
